function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.726 20.033C1.728 10.22 10.558 3.09 20.448 4.094c9.88.995 17.084 9.766 16.072 19.579-1.002 9.812-9.832 16.96-19.722 15.957a18.157 18.157 0 0 1-3.3-.638l-5.918 3.35a.869.869 0 0 1-1.238-.864l-.057-6.651h.019C2.371 31.168.14 25.783.726 20.033",
  fill: "#2175D9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.21 23.654h19.343c8.32 0 15.08 6.698 15.08 14.963 0 7.702-5.928 14.053-13.406 14.869v5.732c0 .61-.681.985-1.21.666L39.55 53.57H30.2c-8.32 0-15.07-6.698-15.07-14.963.01-8.255 6.76-14.953 15.08-14.953",
  fill: "#FFB511",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.77 21.9c0 .919.747 1.66 1.673 1.66.927 0 1.674-.741 1.674-1.66 0-.92-.747-1.66-1.674-1.66-.926 0-1.673.74-1.673 1.66M10.946 21.9c0 .919.747 1.66 1.673 1.66.927 0 1.674-.741 1.674-1.66 0-.92-.747-1.66-1.674-1.66-.926 0-1.673.74-1.673 1.66M22.594 21.9c0 .919.747 1.66 1.673 1.66.927 0 1.674-.741 1.674-1.66 0-.92-.747-1.66-1.674-1.66-.926 0-1.673.74-1.673 1.66",
  fill: "#F7F5F0",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.789 14.509c0 3.264 2.666 5.91 5.956 5.91 3.29 0 5.956-2.646 5.956-5.91 0-3.265-2.666-5.91-5.956-5.91-3.28 0-5.956 2.645-5.956 5.91",
  fill: "#E74536",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.17 51.356a3.04 3.04 0 0 0 3.053 3.03c1.683 0 3.054-1.35 3.054-3.03a3.04 3.04 0 0 0-3.054-3.03 3.04 3.04 0 0 0-3.054 3.03",
  fill: "#0F1941",
  fillRule: "nonzero"
}));
function SvgTypeBuyerCustomer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeBuyerCustomer);
export default __webpack_public_path__ + "static/media/TypeBuyerCustomer.9dc6eb505a67bfc2896c55acf45cd6b7.svg";
export { ForwardRef as ReactComponent };